export const work = [
  {
    company: "WEB4ALL",
    position: "WEB DEVELOPER",
    tasks: [
      "✔ Designed and Implemented various client websites, deployed and managed them.",
      "✔ Managed company server tiers, domains and user subscriptions",
      "✔ Worked with clients on accounts, payments and service subscriptions and activation.",
    ],
    location: "Nairobi, Kenya",
  },
  {
    company: "EMTEC CORP",
    position: "FRONTEND DEVELOPER",
    tasks: [
      "✔ Helped design and implement a versatile and responsive client dashboard.",
      "✔ Created and improved charts and visualization of data from back-end.",
      "✔ Improved rendering speed of the UI and fixed User Interface design issues .",
      "✔ Researched and implemented frameworks for SASS to encourage internal use of modular CSS ",
    ],
    location: "LONDON, UK",
  },
  {
    company: "PRAGMIDEA",
    position: "FULLSTACK DEVELOPER",
    tasks: [
      "✔ Refined and impleneted various product designs and mockups to create fast versatile software products for clients",
      "✔ Conducted code reviews with other developers to ensure quality product delivery ",
      "✔ Implemented internal products for use in workflow management and time conservation",
    ],
    location: "MILAN, ITALY",
  },
  {
    company: "QONECTR",
    position: "WEB & MOBILE APP DEVELOPER",
    tasks: [
      "✔ Interpreted and  designed user interfaces to consume company data API's",
      "✔ Designed and implemented drivers and trips visualization dashboard",
    ],
    location: "NAIROBI, KENYA",
  },
  {
    company: "PANGA APPS",
    position: "DEVELOPER & CONSULTANT",
    tasks: [
      "✔ Refine users needs and develop solutions to meet thier specific needs",
      "✔ Develop and deploy various user software solutions for direct consumptions",
    ],
    location: "NAIROBI, KENYA",
  },
];
